import React, { useEffect, useState } from "react";
import TableAvatar from "./TableAvatar";
import moment from "moment";
import Breadcrumbs from "../../../components/Breadcrumbs";
import AttendenceModelPopup from "../../../components/modelpopup/AttendenceModelPopup";
import "../../../assets/css/pagination.css";
import {
  getFirstDateOfCurrentMonth,
  getMonthOfCurrentMonth,
} from "../../../utils/formatDateInTimezone";
import { companyID, getEmployeeLocalDetails } from "./../../../auth";
import { months } from "../../../utils/data";
import SearchBox from "../../../components/SearchBox";
import api from "../../../api/axios";
import TooltipWrapper from "../../../utils/TooltipWrapper";
import FilterComponent from "../../../components/FilterComponent";
import { getDepartmentById } from "../../../services/departmentService";
import ExportAttendanceModal from "../../../components/modelpopup/ExportAttendanceModal";
import { Button } from "react-bootstrap";
import { exportAttendanceData } from "../../../services/attendanceService";
import EmployeeMultiSelect from "../../../components/EmployeeMultiSelect";
import { useEmployees } from "../../../hooks/useEmployees";

const AttendenceAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const employeeDetails = getEmployeeLocalDetails();
  const [paginationValue, setPaginationValue] = useState(10);
  const [modalData, setModalData] = useState(null);
  const [employeeAttendance, setEmployeeAttendance] = useState([]);
  const [fullAttendanceData, setFullAttendanceData] = useState([]); // New state for full dataset
  const [selectedMonth, setSelectedMonth] = useState(getMonthOfCurrentMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [roleId, setRoleId] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [renderAttendanceData, setRenderAttendanceData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [monthDates, setMonthDates] = useState([]);
  const [attendanceColor, setAttendanceColor] = useState({});
  const [companyWorkingDays, setCompanyWorkingDays] = useState(null);
  const [reRenderAttendanceData, setReRenderAttandanceData] = useState(false);
  const [filterOptions, setFilterOptions] = useState([
    { key: "Active", label: "status", value: [1], category: "Status" },
    { key: "Inactive", label: "status", value: [0], category: "Status" },
    { key: "All Employees", label: "status", value: null, category: "Status" },
  ]);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const { options: employeeOptions, loading: loadingEmployees } =
    useEmployees({status: 1});
  const employee_role = localStorage.getItem("employee_role");
  const employeeID = localStorage.getItem("employeeID");
  const company_id = companyID();

  useEffect(() => {
    setRoleId(employee_role);
    setEmployeeId(employeeID);
  }, []);

  const month = `${selectedYear}-${selectedMonth}`;
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i
  );

  const attendaceData = async (params = { status: 1 }) => {
    console.log("working...................");
    let start_date = `${selectedYear}-${selectedMonth}-01`;
    const currentMonth = moment().format("YYYY-MM");
    const company_id = companyID();
    try {
      let finalParams = { ...params };
      if (
        employeeDetails.employee_role != 1 &&
        employeeDetails.working_departments?.length
      ) {
        if (!("department_id" in finalParams))
          finalParams.department_id = employeeDetails.working_departments;
      }

      // Add selected employee IDs to the API call - don't add to finalParams as we handle it separately in URL
      // if (selectedEmployeeIds.length > 0) {
      //   finalParams.employee_id = selectedEmployeeIds;
      // }

      const queryParams = new URLSearchParams();
      Object.entries(finalParams).forEach(([key, value]) => {
        if (key === "employee_id") return; // Skip employee_id as we handle it separately
        if (Array.isArray(value)) {
          value.forEach((val) => {
            if (val !== null && val !== undefined && val !== "") {
              queryParams.append(key, val);
            }
          });
        } else {
          queryParams.append(key, value);
        }
      });

      // Build employee_id parameter for URL
      let employeeIdParam = "";
      if (selectedEmployeeIds.length > 0) {
        employeeIdParam = selectedEmployeeIds.join(",");
      }

      const response = await api.get(
        `api/attendance/export/record?company_id=${company_id}&employee_id=${employeeIdParam}&from=${month}&to=${month}&${queryParams.toString()}`
      );
      if (response?.data?.success === true) {
        const fullData = response?.data?.result?.months[0]?.monthRows || [];
        const total_pages =
          fullData.length > 0
            ? Math.ceil(fullData.length / paginationValue)
            : 0;
        const paginatedData = fullData.slice(
          (currentPage - 1) * paginationValue,
          currentPage * paginationValue
        );

        setFullAttendanceData(fullData); // Store full dataset
        setEmployeeAttendance(paginatedData); // Store paginated data
        setTotalPages(total_pages);
        setMonthDates(response?.data?.result?.months[0]?.headerDays);
        setAttendanceColor(response?.data?.result?.legend);
        try {
          const company_working_days = await api.get(
            `api/attendance/company-working-days/${company_id}?month=${selectedMonth}&year=${selectedYear}`
          );
          if (company_working_days?.data?.success) setCompanyWorkingDays(company_working_days.data.totalWorkingDays);
          else setCompanyWorkingDays(null);
        } catch (err) {
          console.error("error fetching company working days", err);
          setCompanyWorkingDays(null);
        }

        setRenderAttendanceData(false);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("error fetching attendance", err);
    }
  };

  const fetchDepartments = async () => {
    try {
      const departments = await getDepartmentById(company_id);
      if (!departments?.result?.length) {
        return;
      }
      const mappedDepartments = departments.result
        .filter((dept) => {
          if (
            employeeDetails.employee_role != 1 &&
            employeeDetails.working_departments?.length
          ) {
            return employeeDetails?.working_departments?.includes(dept.id);
          } else if (employeeDetails.employee_role == 1) {
            return true;
          } else {
            return false;
          }
        })
        .map((dept) => ({
          key: dept.department_name,
          label: "department_id",
          value: dept.id,
          category: "Department",
        }));

      setFilterOptions((prevOptions) => [...prevOptions, ...mappedDepartments]);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  useEffect(() => {
    attendaceData();
    fetchDepartments();
  }, []);

  useEffect(() => {
    attendaceData();
  }, [
    selectedMonth,
    selectedYear,
    renderAttendanceData,
    reRenderAttendanceData,
    selectedEmployeeIds,
  ]);

  // New useEffect to handle pagination changes
  useEffect(() => {
    const paginatedData = fullAttendanceData.slice(
      (currentPage - 1) * paginationValue,
      currentPage * paginationValue
    );
    setEmployeeAttendance(paginatedData);
    const total_pages =
      fullAttendanceData.length > 0
        ? Math.ceil(fullAttendanceData.length / paginationValue)
        : 0;
    setTotalPages(total_pages);
  }, [currentPage, paginationValue, fullAttendanceData]);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const exportAttendance = async (params) => {
    try {
      await exportAttendanceData(params);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employees Attendance"
            title="Dashboard"
            subtitle="Employees Attendance"
          />
          <div className="mb-3 d-flex justify-content-end gap-2">
            <div style={{ width: "280px", position: "relative" }}>
              <EmployeeMultiSelect
                options={employeeOptions}
                selectedValues={selectedEmployeeIds}
                onChange={setSelectedEmployeeIds}
                placeholder="Select Employees..."
                loading={loadingEmployees}
              />
            </div>

            <div>
              <select
                className="form-select"
                value={selectedYear}
                onChange={handleYearChange}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <select
                className="form-select"
                value={selectedMonth}
                onChange={handleMonthChange}
              >
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <TooltipWrapper tooltipText="Filter">
                <FilterComponent
                  filterOptions={filterOptions}
                  onApplyFilter={(selectedFilter) => {
                    const queryParams = Object.entries(selectedFilter)?.length
                      ? selectedFilter
                      : { status: 1 };
                    attendaceData(queryParams);
                  }}
                  filterLabel="Filter Employees"
                  resetLabel="Reset Filter"
                  applyLabel="Apply"
                />
              </TooltipWrapper>
            </div>
            <div>
              <Button variant="link" onClick={() => setShowModal(true)}>
                Export Attendance
              </Button>
              <ExportAttendanceModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                exportSheet={exportAttendance}
              />
            </div>
          </div>
          <SearchBox setPaginationValue={setPaginationValue} />
          <TableAvatar
            uniqueDatesForMonth={monthDates}
            paginatedData={employeeAttendance}
            companyWorkingDays={companyWorkingDays}
            setRenderAttendanceData={setRenderAttendanceData}
            setReRenderAttandanceData={setReRenderAttandanceData}
          />
          {employeeAttendance.length !== 0 && (
            <div className="container mt-3">
              <div className="row justify-content-start attendance-color-code-box">
                {Object.keys(attendanceColor).map(
                  (key) =>
                    attendanceColor[key]?.status != "No Record" && (
                      <div
                        key={key}
                        className="col-6 col-sm-4 col-md-2 d-flex align-items-center mb-2 gap-1"
                      >
                        <div
                          className="circle"
                          style={{
                            backgroundColor: attendanceColor[key].color,
                            color: attendanceColor[key].color,
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                          }}
                        ></div>
                        <span>{attendanceColor[key].status}</span>
                      </div>
                    )
                )}
                {/* <div className="col-6 col-sm-4 col-md-2 d-flex align-items-center mb-2 gap-1">
                  <div
                    className="circle"
                    style={{
                      backgroundColor: "#6d7584",
                      color: "#6d7584",
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                    }}
                  ></div>
                  <span>Ongoing </span>
                </div> */}
              </div>
            </div>
          )}

          <div className="pagination-in-attendance">
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={
                  currentPage === index + 1 ? "active btn-primary" : ""
                }
              >
                {index + 1}
              </button>
            ))}
          </div>
          {employeeAttendance?.length == 0 && (
            <div className="row">
              <h1 className="text-center mt-5" style={{ color: "#C7C8CC" }}>
                {" "}
                No Attendance Found
              </h1>
            </div>
          )}
        </div>
      </div>

      {/* {modalData && (
        <AttendenceModelPopup
          data={modalData}
          
        />
      )} */}
    </>
  );
};

export default AttendenceAdmin;
